import { defineMessages } from "react-intl";

import {
	hcvCurrentStateMessages,
	hcvTreatedEverMessages,
	treatedTypeMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/chronic-liver-failure/chronicLiverFailureHcv";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	chronicLiverFailureHcv: {
		id: "ktx.form.chronic_liver_failure_hcv",
		defaultMessage: "HCV"
	},
	currentState: {
		id: "ktx.form.chronic_liver_failure_hcv.current_state",
		defaultMessage: "Jelenlegi státusz"
	},
	hcvTreatedEver: {
		id: "ktx.form.chronic_liver_failure_hcv.treated_ever",
		defaultMessage: "Kezelést kapott-e valaha?"
	},
	treatedType: {
		id: "ktx.form.chronic_liver_failure_hcv.treated_type",
		defaultMessage: "Kezelés típusa"
	},
	hcvTreatedComment: {
		id: "ktx.form.chronic_liver_failure_hcv.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	hcvCurrentState: {
		type: "field",
		path: ["hcvCurrentState"],
		label: messages.currentState,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: hcvCurrentStateMessages }
		}
	},
	hcvTreatedEver: {
		type: "field",
		path: ["hcvTreatedEver"],
		label: messages.hcvTreatedEver,
		errorMessages: genericErrorMessages,
		input: {
			type: "select",
			props: { labels: hcvTreatedEverMessages }
		}
	},
	treatedType: {
		type: "field",
		path: ["treatedType"],
		label: messages.treatedType,
		errorMessages: genericErrorMessages,
		input: {
			type: "checkbox-group",
			props: { labels: treatedTypeMessages }
		}
	},
	hcvTreatedComment: {
		type: "field",
		path: ["hcvTreatedComment"],
		label: messages.hcvTreatedComment,
		errorMessages: genericErrorMessages,
		input: {
			type: "textarea",
			props: {}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.hcvCurrentState }] },
		{ columns: [{ width: 12, field: fields.hcvTreatedEver }] },
		{ columns: [{ width: 12, field: fields.treatedType }] },
		{ columns: [{ width: 12, field: fields.hcvTreatedComment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_chronicLiverFailureHcv",
	value: {
		schemaId: "chronicLiverFailureHcv",
		title: messages.chronicLiverFailureHcv,
		validator,
		fieldset,
		applyCurrentDate: true,
		defaults: [
			{
				path: [],
				query: {
					interpretation: {
						vocab: "ktx",
						code: "hcv_chronic_liver_failure_statement"
					}
				}
			}
		]
	}
};
